/**
 * Copyright 2022 Design Barn Inc.
 */

import * as React from 'react';

export const NoLikes: React.FC = () => (
  <svg width="160" height="250" viewBox="0 0 160 250">
    <path
      d="M48.0077 193C48.0077 193 58.7979 213.457 46.4341 234.588H112.624C112.624 234.588 103.757 221.1 109.502 192.476L48.0077 193Z"
      fill="#59C2E8"
    />
    <path
      d="M120.068 250H38.9908C31.5415 250 25.5029 243.962 25.5029 236.512C25.5029 229.063 31.5415 223.024 38.9908 223.024H120.068C127.517 223.024 133.556 229.063 133.556 236.512C133.556 243.962 127.517 250 120.068 250Z"
      fill="#C2EAFB"
    />
    <path
      d="M147.604 39.2655C147.604 60.3995 130.472 77.5311 109.338 77.5311C88.2043 77.5311 71.0728 60.3995 71.0728 39.2655C71.0728 18.1316 88.2043 1 109.338 1C130.472 1 147.604 18.1316 147.604 39.2655Z"
      fill="#F9EE80"
    />
    <path
      d="M109.34 0C88.401 0 71.3993 16.8218 71.0886 37.687C84.8732 38.4304 92.1636 35.4431 100.167 31.4577C100.973 31.057 101.804 30.6424 102.688 30.2218C107.155 28.0947 116.05 27.3444 121.602 29.6403C122.234 29.925 124.036 30.9751 125.352 31.7424C131.416 35.2762 139.177 39.7882 147.537 40.4875C147.579 39.7522 147.606 39.0119 147.606 38.2655C147.606 17.1326 130.473 0 109.34 0Z"
      fill="#DD6642"
    />
    <path
      d="M87.5968 105.777C87.5968 126.911 70.4652 144.043 49.3312 144.043C28.1973 144.043 11.0657 126.911 11.0657 105.777C11.0657 84.6433 28.1973 67.5117 49.3312 67.5117C70.4652 67.5117 87.5968 84.6433 87.5968 105.777Z"
      fill="#FFB3C2"
    />
    <path
      d="M49.3331 67.5117C28.394 67.5117 11.3923 84.3336 11.0815 105.199C24.8661 105.942 32.1566 102.955 40.1604 98.9694C40.9657 98.5687 41.7969 98.1541 42.6811 97.7335C47.1481 95.6064 56.0431 94.8561 61.5951 97.152C62.2265 97.4368 64.0289 98.4868 65.3447 99.2541C71.4093 102.788 79.1703 107.3 87.5298 107.999C87.5717 107.264 87.5987 106.524 87.5987 105.777C87.5987 84.6443 70.4661 67.5117 49.3331 67.5117Z"
      fill="#E7896E"
    />
    <path
      d="M94.0306 205.585H64.2075C21.603 202.438 -2.89404 178.047 0.274475 142.867C0.274475 130.824 10.5532 121.062 23.2335 121.062H137.108C149.789 121.062 159.058 129.492 159.016 142.867C160.186 181.645 137.345 201.764 94.0306 205.585Z"
      fill="#C2EAFB"
    />
    <path
      d="M64.2072 205.585H91.9979C84.9056 199.856 75.7409 194.096 75.7409 194.096C12.9293 157 33.4488 132.431 51.3175 121.062H23.2332C10.5529 121.062 0.274149 130.824 0.274149 142.867C-2.89541 178.048 21.6027 202.438 64.2072 205.585Z"
      fill="#91D4F2"
    />
    <path
      d="M79.5288 166.186C76.5425 166.186 73.735 164.773 71.6239 162.208C70.433 160.761 70.433 158.415 71.6239 156.968C72.8148 155.521 74.7461 155.521 75.937 156.968C77.9172 159.374 81.1403 159.374 83.1206 156.968C84.3115 155.521 86.2428 155.521 87.4337 156.968C88.6246 158.415 88.6246 160.761 87.4337 162.208C85.3226 164.773 82.5151 166.186 79.5288 166.186Z"
      fill="#414C59"
    />
    <path
      d="M52.1614 161.34C49.0352 161.34 46.5005 158.805 46.5005 155.679V148.16C46.5005 145.034 49.0352 142.499 52.1614 142.499C55.2876 142.499 57.8223 145.034 57.8223 148.16V155.679C57.8223 158.805 55.2876 161.34 52.1614 161.34Z"
      fill="#414C59"
    />
    <path
      d="M107.912 161.34C104.786 161.34 102.251 158.805 102.251 155.679V148.16C102.251 145.034 104.786 142.499 107.912 142.499C111.038 142.499 113.573 145.034 113.573 148.16V155.679C113.573 158.805 111.038 161.34 107.912 161.34Z"
      fill="#414C59"
    />
  </svg>
);
